import AOS from 'aos';

AOS.init({
	duration: 1200,
	disable: 'mobile',
	once: true,
})
